// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"1f8c558f","851":"12a596b0"}[chunkId] + ".chunk.js";
};